import axios from 'axios';
import type { SignInResponse } from '../types/customer';
import { attachRefreshInterceptor } from './axiosInterceptorFactory';

const instance = axios.create({
  baseURL: import.meta.env.VITE_CUSTOMER_SERVICE_API_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
  timeout: 20000,
});

// Attach shared 401 refresh interceptor
const { setCallbacks } = attachRefreshInterceptor(instance, async () => {
  const { data } = await instance.get<SignInResponse>('/api/public/auth/refresh-token');
  return data;
});

/**
 * Register callbacks for AuthContext to sync React state after silent refresh
 */
export function registerAuthInterceptorCallbacks(
  onSuccess: ((result: SignInResponse) => void) | null,
  onFailure: (() => void) | null
) {
  setCallbacks(onSuccess, onFailure);
}

export default instance;
